import { render, staticRenderFns } from "./InvoicedMonthlyStorageLogs.vue?vue&type=template&id=666e6998"
import script from "./InvoicedMonthlyStorageLogs.vue?vue&type=script&lang=js"
export * from "./InvoicedMonthlyStorageLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports